import Vue from "vue";
require('moment/locale/ar');

const moment = require('moment');
Vue.use(require('vue-moment'), {
  moment,
});